/* SANIKB homepage · Canton Fair 2026 notice — phase + motion.  [Claude 2026-09-29] Local mockup, not published.
   - Phase = today's calendar date in the fair's own time zone (data-cf-utc-offset, +08:00 = Guangzhou; China has no
     daylight saving) against the fair days: soon (N days to go) / eve (opens tomorrow) / on (day N of 5) / last (last day)
     / after. The official site has not published the opening hours of the 140th session, so the section only makes
     statements that are true all day long in Guangzhou: it counts days, never hours, and nothing claims "open right now".
   - The content is always final and correct. Motion is only added on top, for a part that is still wholly below the
     fold when the page starts, and it plays when the visitor scrolls that part into view:
       plate  (its top 22 % up the screen): the gold rule draws, then 10.1 and L27 rise into place character by character,
              each from a slot at its own baseline — only the right characters ever show, nothing rolls through other values;
       when   (its top 12 % up the screen): the status line fades in with its number rising the same way, then the day
              strip lights the opening day / today;
       photo  (its top 8 % up the screen): settles from 106 % to 100 %.
     A part that comes into view from above (the visitor jumped past it, came back up, or the page restored its scroll
     position below it) shows its final state at once. Parts already on screen when the page starts never move, so a
     reload never hides what was just painted.
   - The date is re-checked once a minute while the section is on screen and the tab is visible. At midnight in Guangzhou
     the changed digit is replaced (old one leaves upward, new one rises in; only the two real values ever show).
   - Only transform + opacity (+ one colour transition on the day strip). No loops.
   - prefers-reduced-motion: final state at once, no motion.
   - Preview, only when the section carries data-cf-preview: ?state=before|eve|during|last|after,
     ?now=YYYY-MM-DDTHH:MM (read in the fair's time zone; the clock keeps running from there), ?motion=reduce.
*/
(function () {
  'use strict';

  var MIN = 60000, HOUR = 3600000, DAY = 86400000;
  var CUT = {media: 0.08, plate: 0.22, when: 0.12};   // how far up the screen a part's top must be before its motion plays

  function parseOffset(s) {                       // "+08:00" -> 480 (minutes east of UTC)
    var m = /^([+-])(\d{2}):?(\d{2})$/.exec(String(s || '').trim());
    return m ? (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10)) : 480;
  }
  function parseLocal(s, offMin) {                // "YYYY-MM-DD[THH:MM[:SS]]" in the fair's zone -> epoch ms
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/.exec(String(s || '').trim());
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)) - offMin * MIN;
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(ms) { var d = new Date(ms); return d.getUTCFullYear() + pad2(d.getUTCMonth() + 1) + pad2(d.getUTCDate()); }

  function readConfig(root) {
    var a = function (n, d) { var v = root.getAttribute('data-cf-' + n); return v == null || v === '' ? d : v; };
    var off = parseOffset(a('utc-offset', '+08:00'));
    var days = Math.max(1, parseInt(a('days', '5'), 10) || 5);
    var start = parseLocal(a('start', ''), off);
    return {
      off: off, days: days, start: start, end: start + days * DAY,
      first: Math.floor((start + off * MIN) / DAY),                                        // opening day, as a day number in the fair's zone
      startDate: ymd(start + off * MIN), endDate: ymd(start + off * MIN + days * DAY),   // all-day, end exclusive
      uid: a('ics-uid', 'canton-fair@sanikb.com'), file: a('ics-file', 'SANIKB-Canton-Fair.ics'),
      title: a('ics-title', 'SANIKB at the Canton Fair'), location: a('ics-location', ''),
      description: a('ics-description', ''), url: a('ics-url', '')
    };
  }

  function phaseAt(cfg, now) {                    // by calendar date in the fair's zone
    var k = Math.floor((now + cfg.off * MIN) / DAY) - cfg.first;       // 0 = opening day
    if (k < 0) return {phase: k === -1 ? 'eve' : 'soon', state: 'before', d: -k, key: 'b' + (-k)};   // d = days to go
    if (k < cfg.days) return {phase: k + 1 === cfg.days ? 'last' : 'on', state: 'during', day: k + 1, key: 'd' + (k + 1)};
    return {phase: 'after', state: 'after', key: 'a'};
  }

  function readPreview(root, cfg) {
    var o = {};
    if (!root.hasAttribute('data-cf-preview')) return o;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return o; }
    var now = q.get('now'), st = q.get('state');
    if (now) { var t = parseLocal(now, cfg.off); if (!isNaN(t)) o.now = t; }
    if (o.now == null && st) {
      var at = {before: cfg.start - 24 * DAY + 10 * HOUR,                        // 24 days to go
                eve: cfg.start - 4 * HOUR,                                       // 20:00 the evening before
                during: cfg.start + Math.floor(cfg.days / 2) * DAY + 11 * HOUR + 20 * MIN,
                last: cfg.start + (cfg.days - 1) * DAY + 11 * HOUR,
                after: cfg.end + 10 * HOUR}[st];
      if (at != null) o.now = at;
    }
    if (q.get('motion') === 'reduce') o.reduce = true;
    return o;
  }

  /* ---------------------------------------------------------------- characters
     A value becomes a screen-reader copy + one cell per character (aria-hidden). While a character moves, its cell clips
     it at the cell's own line box (see .cf-ch in the CSS), so it rises out of a slot and nothing else is ever drawn. */
  // [Claude 2026-09-30] review: one inline-block per character loses the font's kerning ('0.' '.1' in 10.1), so the split
  // booth ended 18-30 px wider than the static text. Measure the kerned advance of every character in the unsplit text
  // first, then give each cell the difference as a margin (in em, so it holds when the size follows the viewport).
  function advances(el) {
    var tn = el.firstChild;
    if (!tn || tn.nodeType !== 3 || el.childNodes.length !== 1 || !tn.length) return null;
    var fs = parseFloat(getComputedStyle(el).fontSize) || 0;
    if (!fs || !el.getClientRects().length) return null;
    var r = document.createRange(), prev = 0, out = [];
    for (var i = 1; i <= tn.length; i++) {
      r.setStart(tn, 0); r.setEnd(tn, i);
      var w = r.getBoundingClientRect().width;
      out.push(w - prev); prev = w;
    }
    return {adv: out, fs: fs};
  }
  function build(el, text) {
    var keepSr = !el.closest('[aria-hidden="true"]');
    var kern = el.textContent === text ? advances(el) : null;
    el.textContent = '';
    if (keepSr) { var sr = document.createElement('span'); sr.className = 'cf-sr'; sr.textContent = text; el.appendChild(sr); }
    var vis = document.createElement('span'); vis.className = 'cf-vis';
    if (keepSr) vis.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < text.length; i++) {
      var c = document.createElement('span'); c.className = 'cf-ch';
      var g = document.createElement('span'); g.className = 'cf-ch-g'; g.textContent = text.charAt(i) === ' ' ? '\u00a0' : text.charAt(i);
      c.appendChild(g); vis.appendChild(c);
    }
    el.appendChild(vis);
    el.__cfText = text;
    if (kern && kern.adv.length === text.length) {
      var cells = vis.children;
      for (var j = 0; j < cells.length; j++) {
        var d = kern.adv[j] - cells[j].getBoundingClientRect().width;
        if (Math.abs(d) > .05) cells[j].style.marginRight = (d / kern.fs).toFixed(4) + 'em';
      }
    }
  }
  function delays(el, t0, step) {                 // stagger: --cf-delay on every character cell
    var cells = el ? el.querySelectorAll('.cf-ch') : [];
    for (var i = 0; i < cells.length; i++) cells[i].style.setProperty('--cf-delay', (t0 + i * step) + 'ms');
  }
  function setSr(el, text) { var sr = el.querySelector(':scope > .cf-sr'); if (sr) sr.textContent = text; }
  function instant(el, fn) {                      // apply a change with every transition inside el switched off
    el.classList.add('cf-instant'); fn(); void el.offsetWidth; el.classList.remove('cf-instant');
  }
  function replay(el, cls, ms) {                  // (re)start a CSS animation class, drop it when done
    clearTimeout(el['__cf_' + cls]);
    el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
    el['__cf_' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
  }

  /* ---------------------------------------------------------------- calendar file */
  function icsEscape(t) { return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function utf8Len(ch) { var c = ch.codePointAt(0); return c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4; }
  function icsFold(line) {                        // RFC 5545: max 75 octets per line, continuation lines start with a space
    var out = '', n = 0;
    for (var ch of line) {
      var b = utf8Len(ch);
      if (n + b > 75) { out += '\r\n '; n = 1; }
      out += ch; n += b;
    }
    return out;
  }
  function icsText(cfg) {
    var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
    var desc = cfg.description + (cfg.url ? '\nRequest a meeting: ' + cfg.url : '');
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//SANIKB//Canton Fair notice//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VEVENT', 'UID:' + cfg.uid, 'DTSTAMP:' + stamp,
      'DTSTART;VALUE=DATE:' + cfg.startDate, 'DTEND;VALUE=DATE:' + cfg.endDate,
      'SUMMARY:' + icsEscape(cfg.title)];
    if (cfg.location) lines.push('LOCATION:' + icsEscape(cfg.location));
    if (desc) lines.push('DESCRIPTION:' + icsEscape(desc));
    if (cfg.url) lines.push('URL:' + cfg.url);
    lines.push('TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR');
    return lines.map(icsFold).join('\r\n') + '\r\n';
  }
  function downloadIcs(cfg) {
    var blob = new Blob([icsText(cfg)], {type: 'text/calendar;charset=utf-8'});
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = cfg.file; a.rel = 'noopener'; a.style.display = 'none';
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  /* ---------------------------------------------------------------- one section */
  function init(root) {
    if (!root || root.__cf) return;
    var cfg = readConfig(root);
    if (isNaN(cfg.start)) return;                 // no valid date: leave the static markup alone
    var pv = readPreview(root, cfg);
    var t0 = Date.now(), base = pv.now;
    var clock = base != null ? function () { return base + (Date.now() - t0); } : function () { return Date.now(); };
    var still = !!pv.reduce || !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hasIO = 'IntersectionObserver' in window;
    var motion = !still && hasIO;
    root.classList.add(motion ? 'cf-motion' : 'cf-still');

    var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return root.querySelectorAll(s); };
    var plate = $('.cf-plate'), when = $('.cf-when'), media = $('.cf-media'), strip = $('.cf-days');
    var rises = Array.prototype.slice.call($$('[data-cf-rise]'));
    var num = {d: $('[data-cf-num="d"]'), day: $('[data-cf-num="day"]')};
    var unitD = $('[data-cf-unit]');
    var localeStrings = {};
    try { localeStrings = JSON.parse(document.getElementById('sk-canton-i18n').textContent || '{}'); } catch (_) {}
    // [Claude 2026-10-20] COPY-02 (HOME-10): optional unit per plural category (CLDR cardinal categories), sent only by
    // languages that need more than day/days. ar: two = dual "يومين", written without the numeral; few = 3-10; many = 11-99;
    // other = 100+. Without day_forms (en/fr/de/es) the day_singular / day_plural branch below runs exactly as before.
    var dayForms = localeStrings.day_forms && typeof localeStrings.day_forms === 'object' ? localeStrings.day_forms : null;
    var dayRules = null;
    if (dayForms) { try { dayRules = new Intl.PluralRules(dayForms.lang || document.documentElement.lang || 'ar'); } catch (_) {} }
    function dayCat(n) {
      if (dayRules) return dayRules.select(n);
      var m = n % 100;                            // no Intl.PluralRules: CLDR Arabic cardinal rule (day_forms is only sent for ar)
      return n === 0 ? 'zero' : n === 1 ? 'one' : n === 2 ? 'two' : (m >= 3 && m <= 10) ? 'few' : (m >= 11 && m <= 99) ? 'many' : 'other';
    }
    var textDecoder = document.createElement('textarea');
    Object.keys(localeStrings).forEach(function (key) { if (typeof localeStrings[key] === 'string' && !/_html$/.test(key)) { textDecoder.innerHTML = localeStrings[key]; localeStrings[key] = textDecoder.value; } });
    var days = Array.prototype.slice.call($$('.cf-day'));
    var cur = null, held = {plate: false, when: false, media: false}, plateAt = 0;
    var running = false, timer = null, inView = !hasIO, observers = [], timers = [];
    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

    [num.d, num.day].forEach(function (el) { if (el) build(el, el.textContent.trim()); });   // tabular digits: no visible change

    function showFor(phase) {
      var els = $$('[data-cf-show]');
      for (var i = 0; i < els.length; i++) els[i].hidden = els[i].getAttribute('data-cf-show').split(/\s+/).indexOf(phase) < 0;
    }
    function visibleStatus() {
      var ps = $$('.cf-status');
      for (var i = 0; i < ps.length; i++) if (!ps[i].hidden) return ps[i];
      return null;
    }

    function paintDays(animate) {                 // the strip is left unlit while its block waits below the fold
      if (held.when || !cur) return;
      var st = cur;
      var apply = function () {
        days.forEach(function (li) {
          var i = +li.getAttribute('data-cf-day');
          var today = st.state === 'during' && i === st.day;
          li.classList.toggle('cf-day--next', st.state === 'before' && i === 1);
          li.classList.toggle('cf-day--today', today);
          li.classList.toggle('cf-day--past', (st.state === 'during' && i < st.day) || st.state === 'after');
          if (today) li.setAttribute('aria-current', 'date'); else li.removeAttribute('aria-current');
        });
      };
      if (animate && motion) apply(); else if (strip) instant(strip, apply); else apply();
    }

    function swapNum(el, text) {                  // midnight, on screen: old value leaves upward, new value rises in
      var old = el.__cfText;
      if (old.length === text.length) {
        el.__cfText = text; setSr(el, text);
        var cells = el.querySelectorAll('.cf-ch');
        for (var i = 0; i < text.length; i++) {   // every changed digit moves at the same moment: no mixed, wrong value can form
          if (old.charAt(i) === text.charAt(i)) continue;
          var c = cells[i], o = c.querySelector('.cf-ch-out');
          if (o) o.parentNode.removeChild(o);
          o = document.createElement('span'); o.className = 'cf-ch-out'; o.setAttribute('aria-hidden', 'true'); o.textContent = old.charAt(i);
          c.firstChild.textContent = text.charAt(i);
          c.appendChild(o);
          replay(c, 'cf-swap', 900);
          (function (o) { later(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 900); })(o);
        }
        return;
      }
      replay(el, 'cf-leave', 320);               // different length (10 -> 9): the whole number leaves, then the new one rises
      later(function () {
        el.classList.remove('cf-leave');
        build(el, text); delays(el, 0, 0);
        replay(el, 'cf-enter', 900);
      }, 300);
    }
    function setNum(el, text, animate) {
      if (!el || el.__cfText === text) return;
      if (animate && el.__cfText != null) swapNum(el, text); else build(el, text);
    }

    function render(st, live) {
      if (cur && cur.key === st.key) return;
      var prev = cur; cur = st;
      var phaseChanged = !prev || prev.phase !== st.phase;
      var anim = !!live && motion && !held.when;
      if (phaseChanged) {
        showFor(st.phase);
        root.setAttribute('data-cf-state', st.state);
        root.setAttribute('data-cf-phase', st.phase);
      }
      root.setAttribute('data-cf-day', st.state === 'during' ? String(st.day) : '');
      if (st.phase === 'soon') {
        setNum(num.d, String(st.d), anim && !phaseChanged);
        var dCat = dayForms ? dayCat(st.d) : null, dForm = dCat && typeof dayForms[dCat] === 'string' && dayForms[dCat] ? dayForms[dCat] : null;   // [Claude 2026-10-20] COPY-02
        if (unitD) unitD.textContent = dForm != null ? dForm : (st.d === 1 ? (localeStrings.day_singular || 'day') : (localeStrings.day_plural || 'days'));
        if (dayForms && num.d) num.d.style.display = dForm != null && dCat === 'two' && dayForms.two_alone ? 'none' : '';   // "بعد يومين", not "بعد 2 يومين"
      } else if (st.phase === 'on') {
        setNum(num.day, String(st.day), anim && !phaseChanged);
      }
      if (phaseChanged && anim) {                  // e.g. the eve turns into day 1: the new status line comes in
        var p = visibleStatus();
        if (p) { p.querySelectorAll('.cf-num').forEach(function (el) { delays(el, 120, 60); }); replay(p, 'cf-in', 1300); }
      }
      paintDays(anim);
    }
    function update(live) { render(phaseAt(cfg, clock()), live); }

    /* ---- motion, per part */
    function below(el) { return el.getBoundingClientRect().top >= window.innerHeight; }   // wholly under the fold
    function watch(el, cut, play, settle) {
      // near the end of a short page the part may never get `cut` up the screen: lower the line to what scrolling can reach
      var vh = window.innerHeight, doc = document.documentElement;
      var lowest = el.getBoundingClientRect().top + window.pageYOffset - Math.max(0, doc.scrollHeight - vh);   // its top at full scroll
      var pct = Math.max(0, Math.min(Math.round(cut * 100), Math.floor((1 - lowest / vh) * 100) - 2));
      var io = new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        if (!e.isIntersecting) return;
        io.disconnect();
        if (e.boundingClientRect.top < 0) settle(); else play();       // came in from above: final state at once
      }, {rootMargin: '0px 0px -' + pct + '% 0px', threshold: 0});
      io.observe(el);
      observers.push(io);
    }

    function holdPlate() {
      held.plate = true;
      rises.forEach(function (el) { build(el, el.textContent.trim()); });
      plate.classList.add('cf-hold');
    }
    function playPlate() {
      held.plate = false; plateAt = Date.now();
      if (rises[0]) delays(rises[0], 150, 70);
      if (rises[1]) delays(rises[1], 360, 70);
      plate.classList.remove('cf-hold'); plate.classList.add('cf-play');
      later(function () { plate.classList.remove('cf-play'); }, 1700);
    }
    function settlePlate() { held.plate = false; instant(plate, function () { plate.classList.remove('cf-hold'); }); }

    function holdWhen() {
      held.when = true;
      when.classList.add('cf-hold');
      if (strip) instant(strip, function () {
        days.forEach(function (li) { li.classList.remove('cf-day--next', 'cf-day--today', 'cf-day--past'); li.removeAttribute('aria-current'); });
      });
    }
    function playWhen() {                          // if the booth started a moment ago, the status line follows it (lag)
      var lag = plateAt ? Math.max(0, plateAt + 380 - Date.now()) : 0;
      held.when = false;
      when.style.setProperty('--cf-lag', lag + 'ms');
      $$('.cf-status .cf-num').forEach(function (el) { delays(el, 80 + lag, 60); });
      when.classList.remove('cf-hold'); when.classList.add('cf-play');
      later(function () { paintDays(true); }, 450 + lag);
      later(function () { when.classList.remove('cf-play'); }, 1500 + lag);
    }
    function settleWhen() {
      held.when = false;
      instant(when, function () { when.classList.remove('cf-hold'); });
      paintDays(false);
    }

    function holdMedia() { held.media = true; media.classList.add('cf-hold'); }
    function playMedia() {
      held.media = false;
      media.classList.remove('cf-hold'); media.classList.add('cf-play');
      later(function () { media.classList.remove('cf-play'); }, 2000);
    }
    function settleMedia() { held.media = false; instant(media, function () { media.classList.remove('cf-hold'); }); }

    // decide what waits before anything is drawn in its final place (same task: no frame is painted in between)
    if (motion) {
      if (plate && below(plate)) holdPlate();
      if (when && below(when)) holdWhen();
      if (media && below(media)) holdMedia();
    }
    render(phaseAt(cfg, clock()), false);
    if (held.plate) watch(plate, CUT.plate, playPlate, settlePlate);
    if (held.when) watch(when, CUT.when, playWhen, settleWhen);
    if (held.media) watch(media, CUT.media, playMedia, settleMedia);

    /* ---- the once-a-minute date check, only while on screen */
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () { update(true); if (running) schedule(); }, MIN - (clock() % MIN) + 40);
    }
    function start() { if (running) return; running = true; update(true); schedule(); }
    function stop() { running = false; clearTimeout(timer); timer = null; }
    function syncTicker() { if (inView && !document.hidden) start(); else stop(); }
    if (hasIO) {
      var ioRoot = new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; syncTicker(); }, {threshold: 0});
      ioRoot.observe(root);
      observers.push(ioRoot);
    } else {
      syncTicker();
    }
    document.addEventListener('visibilitychange', syncTicker);

    var icsBtn = $('[data-cf-ics]');
    function onIcs() { downloadIcs(cfg); }
    if (icsBtn) icsBtn.addEventListener('click', onIcs);

    // read-only handle for QA (no globals) + teardown for the theme editor
    root.__cf = {
      config: cfg, still: still, motion: motion,
      state: function () { return cur; },
      held: function () { return {plate: held.plate, when: held.when, media: held.media}; },
      ticking: function () { return running; },
      now: function () { return clock(); },
      ics: function () { return icsText(cfg); },
      destroy: function () {
        stop();
        observers.forEach(function (o) { o.disconnect(); });
        timers.forEach(clearTimeout);
        document.removeEventListener('visibilitychange', syncTicker);
        if (icsBtn) icsBtn.removeEventListener('click', onIcs);
      }
    };
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.cf'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Shopify theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('.cf') : null;
    if (r) init(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('.cf') : null;
    if (r && r.__cf) r.__cf.destroy();
  });
})();
